import {inject, Injectable} from '@angular/core';
import {IAddAttachmentFile, ValidationType} from '@core/api/data-access';
import {FileUploadType} from '@global-data';
import {patchState} from '@ngrx/signals';
import {FaceMatchService} from '@validations/face-match/data-access';

import {IFaceMatchValidatorTest} from '../schemas';
import {ValidatorStore} from '../store';

@Injectable({
	providedIn: 'root',
	deps: [ValidatorStore],
})
export class ValidatorService {
	public readonly store = inject(ValidatorStore);
	public readonly faceMatchService: FaceMatchService = inject(FaceMatchService);

	constructor() {}

	patch(updaters: Parameters<typeof patchState>[1], store: Parameters<typeof patchState>[0] = this.store): void {
		patchState(store, updaters);
	}

	public reset(): void {
		this.store.reset();
	}

	public getValidatorAttachments(): IAddAttachmentFile[] {
		const attachments: IAddAttachmentFile[] = [];
		const faceMatchTest = this.store.getValidationTestBy({type: ValidationType.FaceMatch})?.as<IFaceMatchValidatorTest>();
		if (faceMatchTest?.results?.resultData?.imageData) {
			const attachment: IAddAttachmentFile = {
				fileData: faceMatchTest.results.resultData.imageData,
				fileType: FileUploadType.Png.replace('.', ''),
			};
			attachments.push(attachment);
		}
		return attachments;
	}
}
